import { Injectable } from '@angular/core';
import { Observable, timer } from 'rxjs';
import { BatchManager } from 'src/app/data/manager/batch/batch.manager';
import { AlgoliaManager } from '../../data/manager/algolia/algolia.manager';
import { DepartmentManager } from '../../data/manager/department/department.manager';
import { ConfigurationManager } from '../../data/manager/configuration/configuration.manager';
import { SasAlgoliaManager } from '../../data/manager-v3/sas-algolia/sas-algolia.manager';
import { PrimeManager } from 'src/app/data/manager/prime/prime.manager';
import { LocalStorageManager } from 'src/app/data/manager/local-storage/local-storage.manager';
import { CustomerManager } from 'src/app/data/manager/customer/customer/customer.manager';
import { Customer } from 'src/app/data/networking/models/customer/customer';
import { first } from 'rxjs/operators';
import { FirebaseManager } from 'src/app/data/manager/firebase/firebase.manager';
import { FirebaseFlags } from 'src/app/data/networking/models/firebase/response/flags';
import { RecaptchaManager } from 'src/app/data/manager/recaptcha/recaptcha.manager';

@Injectable({
  providedIn: 'root',
})
export class AlgoliaVm {
  constructor(public algoliaManager: AlgoliaManager,
    private departments: DepartmentManager,
    private configurationManager: ConfigurationManager,
    private sasAlgolia: SasAlgoliaManager,
    private primeManager: PrimeManager,
    private lsm: LocalStorageManager,
    private batchManager: BatchManager,
    private customerManager: CustomerManager,
    private firebaseManager: FirebaseManager,
    private recaptchaManager: RecaptchaManager
    ) { }

  search(query, page, facets, filters = '', sendIdStoreGroup?, userSearch?): Promise<any> {
    return this.algoliaManager.search(query, (facets || 'marca,categorie,subCategory,fullPrice,Prime'), page, filters, sendIdStoreGroup, null,null,null, ( userSearch ? userSearch : false ));
  }

  getDepartments(): Observable<any> {
    return this.departments.get();
  }

  getOrigin(): Observable<any> {
    return this.configurationManager.getOrigin('ADDED_FROM_SEARCH');
  }

  getFacets(): Observable<any> {
    return this.sasAlgolia.getFacets();
  }

  getConfiguration(): any {
    return this.configurationManager.getConfigurationModule('algolia');
  }

  getPrimeSubscription(): Observable<any> {
    return this.primeManager.getPrimeSubscription(this.lsm.get('customer')?.id || 0);
  }

  setContext(type?: string, data?: any | string): void {
    this.algoliaManager.setContext(type, data);
  }

  logEvent(event: string, data: any) {
    return this.batchManager.logEvent(event, data);
  }

  getLocalCustomer(): Observable<Customer> {
    return this.customerManager.customer;
  }
  
  tryConfig(milis:number){
    return timer(milis)
      .pipe(first());
  }

  async fetchAndActivate(remoteConfig:firebase.remoteConfig.RemoteConfig): Promise<{ searchMarketplace: boolean;}> {
    remoteConfig.settings = {
      minimumFetchIntervalMillis: 60 * 1000,
      fetchTimeoutMillis: 60 * 1000,
    };
    await remoteConfig.fetchAndActivate();
    const searchMarketplace = remoteConfig.getBoolean('search_marketplace');
    return {searchMarketplace};
  }
  
  getCustomer() {
    const {customer} = this.customerManager;
    return customer;
  }

  getRemoteConfig(): Observable<FirebaseFlags> {
    return this.firebaseManager.getRemoteConfig();
  }

   actionsRecaptcha(actionValue: string): Promise<string> {
    return this.recaptchaManager.actionRecaptcha(actionValue);
  }
}
